import React, { useCallback } from "react";
import { newRidgeState } from "react-ridge-state";
import { useNavigation } from "expo-router";
import { DrawerActions } from "@react-navigation/native";

type SlideNavigationPageProps = {
	children: React.ReactElement | null;
	pageKey: string;
	openFromRight: boolean;
};

type SlideNavigationProps = {
	children: React.ReactElement | React.ReactElement[] | null;
};

const slideNavigationComponentState = newRidgeState<string>("");

export function useSlideNavigation(key: string) {
	const [slideNavigationState, setSlideNavigationState] = slideNavigationComponentState.use();
	const navigation = useNavigation();

	const open = useCallback(() => {
		navigation.dispatch(DrawerActions.openDrawer());
		setSlideNavigationState(key);
	}, []);

	const close = useCallback(() => {
		navigation.dispatch(DrawerActions.closeDrawer());
	}, []);

	return { open, close, slideNavigationState };
}
